/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Report_DebriefInputs */



/**
* | output |
* | --- |
* | "Debrief this conversation" |
*
* @param {Chat_Quick_Report_DebriefInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_report_debrief = /** @type {((inputs?: Chat_Quick_Report_DebriefInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Report_DebriefInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Debrief van gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Débriefer cette conversation")
	return /** @type {LocalizedString} */ ("Debrief this conversation")
});